export enum ETypDokumentu {
    SMLOUVY = 'SMLOUVY',
    PRIKAZY = 'PRIKAZY',
    ZADOST = 'ZADOST'
}

export enum EPodTypdokumentuSmlouva {
    SMLOUVA = 'SMLOUVA',
    SMLOUVADLT = 'SMLOUVADLT',
    DODATEK = 'DODATEK',
    DODATEKDLT = 'DODATEKDLT',
    NAVYSENI = 'NAVYSENI',
    NAVYSENIDLT = 'NAVYSENIDLT'
}
export enum EPodTypdokumentuPrikazZapis {
    PREVODNASL = 'PREVODNASL',
    VYPIS = 'VYPIS',
    BLOKACE = 'BLOKACE',
    SEZUPIS = 'SEZUPIS',
    ZAPISBLOK = 'ZAPISBLOK',
    PRODLUZ = 'PRODLUZ',
    SPLYNUTI = 'SPLYNUTI',
    SNIZENI = 'SNIZENI',
    STEPENI = 'STEPENI',
    PREVODITELNOST = 'PREVODITELNOST',
    VYTESNENI = 'VYTESNENI'
}
export enum EPodTypdokumentuPrikazZmena {
    ZMENREGI = 'ZMENREGI',
    ZMENFUZE = 'ZMENFUZE',
    ZMENJINA = 'ZMENJINA',
    ZMENEMISI = 'ZMENEMISI',
    ZMENY = 'ZMENY',
    FORMA = 'FORMA',
    JMENOVITA = 'JMENOVITA',
    ADMINZMENY = 'ADMINZMENY'
}
export enum EPodTypdokumentuPrikazZruseni {
    EMISELIKV = 'EMISELIKV',
    EMISEFUZE = 'EMISEFUZE',
    PREVODZPET = 'PREVODZPET',
    EMISELIST = 'EMISELIST',
    ZRUSPPN = 'ZRUSPPN',
    ADMINZRUS = 'ADMINZRUS',
    PREVODITELNOST = 'PREVODITELNOST',
    ZRUSENI = 'ZRUSENI'
}
export enum EPodTypdokumentuPrikaz {
    ZMENY = 'ZMENY',
    SPLYNUTI = 'SPLYNUTI',
    SNIZENI = 'SNIZENI',
    PREVODITELNOST = 'PREVODITELNOST',
    ZRUSENI = 'ZRUSENI',
    FORMA = 'FORMA',
    VYTESNENI = 'VYTESNENI',
    JMENOVITA = 'JMENOVITA',
    STEPENI = 'STEPENI',
    ADMINZMENY = 'ADMINZMENY',
    ADMINZRUS = 'ADMINZRUS',
    ZRUSPPN = 'ZRUSPPN',
    PRODLUZ = 'PRODLUZ',
    ZMENEMISI = 'ZMENEMISI',
    ZAPISBLOK = 'ZAPISBLOK',
    SEZUPIS = 'SEZUPIS',
    BLOKACE = 'BLOKACE',
    EMISELIKV = 'EMISELIKV',
    EMISEFUZE = 'EMISEFUZE',
    EMISELIST = 'EMISELIST',
    ZMENFUZE = 'ZMENFUZE',
    ZMENJINA = 'ZMENJINA',
    VYPIS = 'VYPIS',
    PREVODNASL = 'PREVODNASL',
    PREVODZPET = 'PREVODZPET',
    ZMENREGI = 'ZMENREGI',
    OMEZPREVOD = 'OMEZPREVOD'
}

export enum EPodTypDokumentu {
    SMLOUVA = 'SMLOUVA',
    SMLOUVADLT = 'SMLOUVADLT',
    DODATEK = 'DODATEK',
    DODATEKDLT = 'DODATEKDLT',
    NAVYSENI = 'NAVYSENI',
    NAVYSENIDLT = 'NAVYSENIDLT',
    ZMENY = 'ZMENY',
    SPLYNUTI = 'SPLYNUTI',
    SNIZENI = 'SNIZENI',
    PREVODITELNOST = 'PREVODITELNOST',
    ZRUSENI = 'ZRUSENI',
    FORMA = 'FORMA',
    VYTESNENI = 'VYTESNENI',
    JMENOVITA = 'JMENOVITA',
    STEPENI = 'STEPENI',
    ADMINZMENY = 'ADMINZMENY',
    ADMINZRUS = 'ADMINZRUS',
    ZRUSPPN = 'ZRUSPPN',
    PRODLUZ = 'PRODLUZ',
    ZMENEMISI = 'ZMENEMISI',
    ZAPISBLOK = 'ZAPISBLOK',
    SEZUPIS = 'SEZUPIS',
    BLOKACE = 'BLOKACE',
    EMISELIKV = 'EMISELIKV',
    EMISEFUZE = 'EMISEFUZE',
    EMISELIST = 'EMISELIST',
    ZMENFUZE = 'ZMENFUZE',
    ZMENJINA = 'ZMENJINA',
    VYPIS = 'VYPIS',
    PREVODNASL = 'PREVODNASL',
    PREVODZPET = 'PREVODZPET',
    ZMENREGI = 'ZMENREGI',
    OMEZPREVOD = 'OMEZPREVOD'
}

export enum EStavPodpisu {
    NEPODEPSAL = 'NEPODEPSAL', // Dokument není podepsán
    ODESLANO = 'ODESLANO', // Odesláno k podpisu
    PODEPSANO = 'PODEPSANO', // Podepsáno a ověreno
    NEOVERENO = 'NEOVERENO', // podpis ověril referent
    OVERENO = 'OVERENO', // soubor podpeslat ale neoveřil se podpis
    ZAMITNUTO = 'ZAMITNUTO', // referent zamítl podpis
    CHYBNYPODPIS = 'CHYBNYPODPIS' //  neprošlo podepsani přes bankid
}

export enum EStavZadostiDok {
    ROZP = 'ROZP',
    DOPL = 'DOPL',
    KDOPLNENI = 'KDOPLNENI',
    AUTKONTROLA = 'AUTKONTROLA',
    AUTKONTROLAPRED = 'AUTKONTROLAPRED',
    CDCPKEKONTR = 'CDCPKEKONTR',
    CDCPKEKONTRPRED = 'CDCPKEKONTRPRED',
    CDCPKONTRPRED = 'CDCPKONTRPRED',
    ZKONTROLOVANO = 'ZKONTROLOVANO',
    AKCEPTOVANO = 'AKCEPTOVANO',
    ZPRACOVANO = 'ZPRACOVANO',
    CDCPKONTR = 'CDCPKONTR',
    KPODPISU = 'KPODPISU',
    PODEPSANO = 'PODEPSANO',
    HOTOVOIIS = 'HOTOVOIIS',
    ZAMITNUTO = 'ZAMITNUTO',
    ZRUSENO = 'ZRUSENO'
}

export enum ETypZpusobPredani {
    CDCP = 'CDCP',
    MD = 'MD',
    MDADMIN = 'MDADMIN',
    PARSYST = 'PARSYST',
    BURZA = 'BURZA'
}

export enum EtypPrilohy {
    VYPISOR = 'VYPISOR',
    VYPISORZMEN = 'VYPISORZMEN',
    VYPISORZAPVYS = 'VYPISORZAPVYS',
    VYPISOREMISAKC = 'VYPISOREMISAKC',
    VYPISORLIKVID = 'VYPISORLIKVID',
    VYPISORJMENLIKVID = 'VYPISORJMENLIKVID',
    VYPISORNOVAFORMA = 'VYPISORNOVAFORMA',
    VYPISORZRUS = 'VYPISORZRUS',
    VYPISORZAPZMENVH = 'VYPISORZAPZMENVH',
    VYPISORZAPZMEN = 'VYPISORZAPZMEN',
    ZAPISSCHUZVL = 'ZAPISSCHUZVL',
    PROSPEKT = 'PROSPEKT',
    DLUHPROG = 'DLUHPROG',
    STATUTCNB = 'STATUTCNB',
    ROZHODNUTICNB = 'ROZHODNUTICNB',
    EMISNIPODMINKY = 'EMISNIPODMINKY',
    EMISNIPODJINY = 'EMISNIPODJINY',
    KUPONY = 'KUPONY',
    PROJEKTPREMENY = 'PROJEKTPREMENY',
    PROJEKTFUZE = 'PROJEKTFUZE',
    OPRAVNENIPODANIPOZ = 'OPRAVNENIPODANIPOZ',
    JINYOPRAVNENIZMENY = 'JINYOPRAVNENIZMENY',
    JINYJMENUJLIKVID = 'JINYJMENUJLIKVID',
    JINY = 'JINY',
    STANOVY = 'STANOVY'
}
